import R1Network from 'pages/BackOfficePage/BackOfficeCategories/R1Network/R1Network';

export default R1Network;
